import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchUserFeatures = createAsyncThunk(
  'billing/fetchUserFeatures',
  async (_, { dispatch }) => {
    const requestParams = {
      url: '/api/billing/user_features',
      method: 'GET'
    }
    const [success, response] = await httpRequest(requestParams)

    if (!success) {
      dispatch(showHttpError(response))
    }

    return { userFeatures: response }
  }
)
